import { generatePath, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { IN_PAGE_NAVIGATION_STATE } from '../Components/RouteTransition';

/**
 * Keeps the selected tab in an optional route param (e.g. `/reports/:tab?`).
 * A missing or unknown param selects the first tab.
 */
export default function useRoutedTab(slugs, param = 'tab') {
    const history = useHistory();
    const { path } = useRouteMatch();
    const params = useParams();
    const activeIndex = Math.max(0, slugs.indexOf(params[param]));

    const selectTab = (nextIndex) => {
        const slug = slugs[nextIndex];
        if (!slug || nextIndex === activeIndex) return;
        history.push({
            pathname: generatePath(path, { ...params, [param]: slug }),
            state: IN_PAGE_NAVIGATION_STATE,
        });
    };

    return [activeIndex, selectTab];
}
